import { render } from "./RewardAction.vue?vue&type=template&id=01c7863a&scoped=true&ts=true"
import script from "./RewardAction.vue?vue&type=script&lang=ts"
export * from "./RewardAction.vue?vue&type=script&lang=ts"

import "./RewardAction.vue?vue&type=style&index=0&id=01c7863a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c7863a"]])

export default __exports__